import './App.css';
import React from 'react';
import Header from "./components/header.js";
import Footer from "./components/footer.js";
import AppRoutes from "./components/routes.js";
import { BrowserRouter } from "react-router-dom";


function App() {
  return (
    <div className="App">
      <div className='container'> 
        <BrowserRouter>
            <Header/>
            <AppRoutes/>
            <Footer />
        </BrowserRouter>
      </div>
    </div>
  ); 
}

export default App;
